import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private toastr: ToastrService) { }

  Success(msg:string,title:string)
  {
    this.toastr.success(msg,title)
  }
  Warning(msg:string,title:string)
  {
    this.toastr.warning(msg,title)
  }
  Error(msg:string,title:string)
  {
    this.toastr.error(msg,title)
  }

}
